export const GetFileSourceLabel = (source: server.dto.ESignFileSources) => {
  switch (source) {
    case "fromTemplate":
      return RESX.ESign.GeneratedFromTemplate;
    case "fromStorage":
      return RESX.ESign.AddedFromStorage;
    case "fromUpload":
      return RESX.ESign.Uploaded;
  }
};